module.exports = __webpack_public_path__ + "static/media/7ICJ4.fa839fc3.jpg";